module.exports = __webpack_public_path__ + "images/no-image-tooltip-479e7eb9.svg";